import { sentimentFormat } from '@op/utils/value';
import {
  IMetricsCardList,
  IMetricsChartList,
  IMetricsList,
  IMetricsSteamList, 
  IRealtimeMentionsType,
  IRealtimeMetrics,
  IRealtimeSegment,
  IRealtimeTableHeaderType,
} from './type';
import { DBO_V } from '@op/utils/format';
import {
  realtimeOpinionCurrHourTips,
  realtimeOpinionLastHourTips,
  realtimeOpinionDailyDiscussPlayerTips,
  realtimeOpinionHourlyAddedMentionsTips,
  realtimeOpinionHourlyNegativeMentionsTips,
  realtimeOpinionMentionsTips,
  TipsMapType,
  realtimeOpinionHourlyAddedMentionsAverageTips,
  realtimeOpinionHourlyNegativeMentionsAverageTips,
} from '@op/components/BubbleCommon';

export const REALTIME_TAB_OPTIONS: {
  text: string;
  value: string;
  tips: TipsMapType;
}[] = [
  {
    text: 'Up to Current Hour',
    value: 'current',
    tips: realtimeOpinionCurrHourTips,
  },
  {
    text: 'Up to Last Hour',
    value: 'last_hour',
    tips: realtimeOpinionLastHourTips,
  },
];

export const REALTIME_METRICS_STEAM_OPTIONS: IMetricsSteamList[] = [
  {
    title: 'Hourly Added Reviews',
    otherTitle: 'Daily Added Reviews',
    valueKey: 'hourly',
    icon: 'new-logo',
    tips: 'by DataBrain Crawling',
    noSubtitle: true,
    keys: {
      total: 'select_all_review',
      positive: 'select_recommend',
      negative: 'select_non_recommend',
    },
  },
  {
    title: 'All Reviews',
    valueKey: 'all',
    icon: 'new-logo',
    tips: 'by DataBrain Crawling',
    keys: {
      total: 'select_all_review_from_release',
      positive: 'select_recommend_from_release',
      negative: 'select_non_recommend_from_release',
    },
  },
  {
    title: 'All Reviews',
    valueKey: 'steam_all',
    icon: 'awesome-steam',
    tips: 'by Steam Homepage',
    tagText: 'Official platform rating',
    keys: {
      total: 'all_reviews',
      positive: 'all_reviews_recommend',
      negative: 'all_reviews_non_recommend',
    },
  },
];

export const REALTIME_ADDED_NEGATIVE_METRICS: IRealtimeMetrics[] = [
  {
    name: 'Hourly Negative%',
    value: 'negative_mentions_ratio',
    color: '#5D86EB',
  },
  {
    name: 'Last Day Hourly Negative%',
    value: 'old_negative_mentions_ratio',
    color: '#A7C2F9',
  },
];

export const REALTIME_DISCUSS_PLAYER_METRICS: IRealtimeMetrics[] = [
  {
    name: 'Hourly Discuss Players',
    value: 'reviewers',
    color: '#5D86EB',
  },
  {
    name: 'Last Day Hourly Discuss Players',
    value: 'old_reviewers',
    color: '#A7C2F9',
  },
];

export const REALTIME_DAILY_MENTIONS_DROPDOWN_OPTIONS: IMetricsChartList[] = [
  {
    text: 'Total Mentions',
    value: 'in_total',
    metrics: [
      {
        name: 'Mentions',
        value: 'mentions',
        color: '#5D86EB',
        accumulate: true,
      },
      {
        name: 'Last Day Mentions',
        value: 'old_mentions',
        color: '#A7C2F9',
        accumulate: true,
      },
    ],
    needRadar: true,
    isMinutes: true,
  },
  {
    text: 'By Sentiment',
    value: 'by_sentiment',
    metrics: [
      {
        name: 'Positive',
        value: 'positive_mentions',
        color: '#F17C86',
        accumulate: true,
      },
      {
        name: 'Neutral',
        value: 'neutral_mentions',
        color: '#6E7794',
        accumulate: true,
      },
      {
        name: 'Negative',
        value: 'negative_mentions',
        color: '#69D19C',
        accumulate: true,
      },
    ],
    showTotal: true,
    title: 'Mentions',
    isMinutes: true,
  },
  {
    text: 'Exclude Neutral',
    value: 'exclude_neutral',
    metrics: [
      {
        name: 'Positive',
        value: 'positive_mentions',
        color: '#69D19C',
        accumulate: true,
      },
      {
        name: 'Negative',
        value: 'negative_mentions',
        color: '#F17C86',
        accumulate: true,
      },
    ],
    showTotal: true,
    title: 'Mentions',
    isMinutes: true,
  },
  {
    text: 'Exclude Low & Invalid',
    value: 'exclude_low_invalid',
    metrics: [
      {
        name: 'High',
        value: 'high_mentions',
        color: '#5D86EB',
        accumulate: true,
      },
      {
        name: 'Medium',
        value: 'medium_mentions',
        color: '#A7C2F9',
        accumulate: true,
      },
    ],
    showTotal: true,
    title: 'Mentions',
    isMinutes: true,
  },
];

export const REALTIME_ADDED_MENTIONS_DROPDOWN_OPTIONS: IMetricsChartList[] = [
  {
    text: 'Total Mentions',
    value: 'in_total',
    metrics: [
      {
        name: 'Hourly Mentions',
        value: 'mentions',
        color: '#5D86EB',
      },
      {
        name: 'Last Day Hourly Mentions',
        value: 'old_mentions',
        color: '#A7C2F9',
      },
    ],
    needRadar: true,
    title: 'Hourly Mentions',
  },
  {
    text: 'By Sentiment',
    value: 'by_sentiment',
    metrics: [
      {
        name: 'Positive',
        value: 'positive_mentions',
        color: '#F17C86',
      },
      {
        name: 'Neutral',
        value: 'neutral_mentions',
        color: '#6E7794',
      },
      {
        name: 'Negative',
        value: 'negative_mentions',
        color: '#69D19C',
      },
    ],
    showTotal: true,
    title: 'Hourly Mentions',
  },
  {
    text: 'Exclude Neutral',
    value: 'exclude_neutral',
    metrics: [
      {
        name: 'Positive',
        value: 'positive_mentions',
        color: '#69D19C',
      },
      {
        name: 'Negative',
        value: 'negative_mentions',
        color: '#F17C86',
      },
    ],
    showTotal: true,
    title: 'Hourly Mentions',
  },
  {
    text: 'Exclude Low & Invalid',
    value: 'exclude_low_invalid',
    metrics: [
      {
        name: 'High',
        value: 'high_mentions',
        color: '#5D86EB',
      },
      {
        name: 'Medium',
        value: 'medium_mentions',
        color: '#A7C2F9',
      },
    ],
    showTotal: true,
    title: 'Hourly Mentions',
  },
];

export const REALTIME_MENTIONS_DROPDOWN: IRealtimeMentionsType[] = [
  'mentions',
  'added_mentions_per_hour',
];

export const REALTIME_METRICS_CARD_OPTIONS: {
  [key: string]: IMetricsCardList[];
} = {
  is_today: [
    {
      title: 'Daily Mentions',
      valueKey: 'mentions',
      tabKey: 'real_time_total_5_minute',
      dropdown: REALTIME_DAILY_MENTIONS_DROPDOWN_OPTIONS,
      tips: realtimeOpinionMentionsTips,
    },
    {
      title: 'Hourly Added Mentions',
      valueKey: 'added_mentions_per_hour',
      tabKey: 'real_time_total',
      dropdown: REALTIME_ADDED_MENTIONS_DROPDOWN_OPTIONS,
      isHourly: true,
      tips: realtimeOpinionHourlyAddedMentionsTips,
    },
    {
      title: 'Hourly Negative%',
      valueKey: 'added_negative_mentions_pct_per_hour',
      tabKey: 'negative_mentions_ratio',
      formatValue: (val: number) => DBO_V.percentageFormat(val * 100),
      metrics: REALTIME_ADDED_NEGATIVE_METRICS,
      isPercent: true,
      isHourly: true,
      needRadar: true,
      tips: realtimeOpinionHourlyNegativeMentionsTips,
    },
    {
      title: 'Daily Discuss Players',
      valueKey: 'discuss_players',
      metrics: REALTIME_DISCUSS_PLAYER_METRICS,
      needRadar: true,
      chartTitle: 'Hourly Discuss Players',
      tips: realtimeOpinionDailyDiscussPlayerTips,
    },
  ],
  default: [
    {
      title: 'Daily Mentions',
      valueKey: 'mentions',
      tabKey: 'real_time_total_5_minute',
      dropdown: REALTIME_DAILY_MENTIONS_DROPDOWN_OPTIONS,
      tips: realtimeOpinionMentionsTips,
    },
    {
      title: 'Hourly Avg. Mentions',
      valueKey: 'avg_mentions_per_hour',
      tabKey: 'real_time_total',
      dropdown: REALTIME_ADDED_MENTIONS_DROPDOWN_OPTIONS,
      tips: realtimeOpinionHourlyAddedMentionsAverageTips,
      chartTitle: 'Hourly Mentions',
    },
    {
      title: 'Hourly Avg. Negative%',
      valueKey: 'avg_negative_mentions_pct_per_hour',
      tabKey: 'negative_mentions_ratio',
      formatValue: (val: number) => DBO_V.percentageFormat(val * 100),
      metrics: REALTIME_ADDED_NEGATIVE_METRICS,
      isPercent: true,
      needRadar: true,
      chartTitle: 'Hourly Negative%',
      tips: realtimeOpinionHourlyNegativeMentionsAverageTips,
    },
    {
      title: 'Daily Discuss Players',
      valueKey: 'discuss_players',
      metrics: REALTIME_DISCUSS_PLAYER_METRICS,
      needRadar: true,
      chartTitle: 'Hourly Discuss Players',
      tips: realtimeOpinionDailyDiscussPlayerTips,
    },
  ],
};

export const REALTIME_CHANNEL_ACCOUNT_OPTIONS: IRealtimeSegment[] = [
  {
    text: 'All',
    value: 'all',
  },
  {
    text: 'Official Account',
    value: 'official',
  },
  {
    text: 'Non-official Account',
    value: 'player',
  },
];

export const REALTIME_CHANNEL_METRICS_COMMON_OPTIONS: IMetricsCardList[] = [
  {
    title: 'Daily Publications',
    valueKey: 'publications',
    dropdown: [
      {
        text: 'In Total',
        value: 'in_total',
      },
      {
        text: 'By Channel',
        value: 'by_channel',
      },
      {
        text: 'By Media Type',
        value: 'by_media_type',
      },
      {
        text: 'By Language',
        value: 'by_language',
      },
    ],
  },
  {
    title: 'Daily Number of Creators',
    valueKey: 'creators',
    dropdown: [
      {
        text: 'In Total',
        value: 'in_total',
      },
      {
        text: 'By Channel',
        value: 'by_channel',
      },
      {
        text: 'By Follower Range',
        value: 'by_follower_range',
      },
    ],
  },
  {
    title: 'Daily Views',
    valueKey: 'views',
    dropdown: [
      {
        text: 'In Total',
        value: 'in_total',
      },
      {
        text: 'By Channel',
        value: 'by_channel',
      },
      {
        text: 'By Media Type',
        value: 'by_media_type',
      },
      {
        text: 'By Language',
        value: 'by_language',
      },
    ],
  },
  {
    title: 'Daily Engagement',
    valueKey: 'engagement',
    dropdown: [
      {
        text: 'In Total',
        value: 'in_total',
      },
      {
        text: 'By Engagement',
        value: 'by_engagement_type',
      },
      {
        text: 'By Channel',
        value: 'by_channel',
      },
      {
        text: 'By Media Type',
        value: 'by_media_type',
      },
      {
        text: 'By Language',
        value: 'by_language',
      },
    ],
  },
  {
    title: 'Daily Sentiment',
    valueKey: 'avg_sentiment',
    dropdown: [
      {
        text: 'In Total',
        value: 'in_total',
      },
      {
        text: 'By Channel',
        value: 'by_channel',
      },
      {
        text: 'By Media Type',
        value: 'by_media_type',
      },
      {
        text: 'By Language',
        value: 'by_language',
      },
    ],
  },
];

export const REALTIME_CHANNEL_METRICS_STREAM_OPTIONS: IMetricsCardList[] = [
  {
    title: 'Channel Count',
    valueKey: 'channel_count',
    dropdown: [
      {
        text: 'By Channel',
        value: 'by_channel',
      },
    ],
  },
  {
    title: 'PCV',
    valueKey: 'pcv_count',
    dropdown: [
      {
        text: 'By Channel',
        value: 'by_channel',
      },
    ],
  },
  {
    title: 'ACV',
    valueKey: 'acv_count',
    dropdown: [
      {
        text: 'By Channel',
        value: 'by_channel',
      },
    ],
  },
];

export const REALTIME_CHANNEL_KEY_VALUE: {
  [key in string]: string[];
} = {
  total: [],
  video: ['posts_video', 'sub_video'],
  posts: ['posts_text', 'sub_text'],
};

export const REALTIME_CHANNEL_LANGUAGE_SORT: {
  [key: string]: string;
} = {
  steam_positive_rate: 'steam_added_positive',
  posts: 'publications',
  sentiment: 'mentions',
};

export const REALTIME_CHANNEL_TYPE_OPTIONS: IRealtimeSegment[] = [
  {
    text: 'Total-3',
    value: 'total',
    icon: 'studio-all',
  },
  {
    text: 'Video',
    value: 'video',
    icon: 'studio-video',
  },
  {
    text: 'Posts-2',
    value: 'posts',
    icon: 'studio-posts',
  },
  {
    text: 'Stream',
    value: 'stream',
    icon: 'studio-streaming',
  },
];

export const METRICS_LIST: IMetricsList = {
  language: [
    {
      title: 'Mentions',
      value: 'mentions',
    },
    {
      title: 'Sentiment',
      value: 'sentiment',
      isAvg: true,
      format: sentimentFormat,
    },
    {
      title: 'Steam Positive Rate',
      value: 'steam_positive_rate',
      isAvg: true,
      format: (val: number) => DBO_V.percentageFormat(val * 100),
      isPercent: true,
    },
    {
      title: 'Posts-1',
      value: 'posts',
    },
    {
      title: 'Views',
      value: 'views',
    },
    {
      title: 'Engagements',
      value: 'engagements',
    },
  ],
  channel: [
    {
      title: 'Mentions',
      value: 'mentions',
    },
    {
      title: 'Sentiment',
      value: 'sentiment',
      isAvg: true,
      format: sentimentFormat,
    },
    {
      title: 'Posts-1',
      value: 'posts',
    },
    {
      title: 'Views',
      value: 'views',
    },
    {
      title: 'Engagements',
      value: 'engagements',
    },
  ],
  stream: [
    {
      title: 'Channel Count',
      value: 'channel_count',
    },
    {
      title: 'PCV',
      value: 'pcv_count',
    },
    {
      title: 'ACV',
      value: 'acv_count',
    },
  ],
};

export const SORT_VIDEO_OPTIONS = [
  { value: 'view', text: 'View' },
  { value: 'engagement', text: 'Engagement' },
  { value: 'follower_number', text: 'Followers', valueKey: 'subscribe' },
];
export const SORT_STREAMING_OPTIONS = [{ text: 'CCV', value: 'live_viewer' }];

export const TABLE_HEADER_TYPE: {
  [key: string]: IRealtimeTableHeaderType;
} = {
  by_channel: 'Channel',
  by_language: 'Language',
  by_media_type: 'Media Type',
  by_follower_range: 'Follower Range',
  by_engagement_type: 'Engagement Type',
};

export const TABLE_LABEL_NAME: {
  [key: string]: string;
} = {
  video_publications: 'Video',
  posts_publications: 'Posts-2',
  posts_comments_engagement: 'Comments on Posts',
  video_engagement: 'Video',
  posts_engagement: 'Posts-2',
  video_comments_engagement: 'Comments on Videos',
  video_views: 'Video',
  posts_views: 'Posts-2',
  likes: 'Likes',
  tweets_comments: 'Comments',
  shares: 'Shares',
  publications: 'Daily Publications',
  creators: 'Daily Number of Creators',
  views: 'Daily Views',
  engagement: 'Daily Engagement',
  avg_sentiment: 'Daily Sentiment',
};

export const REALTIME_STEAM_TIMELINE_CONFIG = {
  steamData: {
    source: 'lifetime_pc_console_timeline',
  },
  databrainData: {
    source: 'from_release_pc_console_timeline',
  },
  addedReviews: {
    source: 'hourly_added_pc_console_timeline',
  },
};

export const EXTRA_FILTER_SENTIMENT: {
  [key: string]: {
    [key: string]: string[] | number[] | string | number | boolean;
  };
} = {
  exclude_neutral: { sentiment: [5, 1] },
  exclude_low_invalid: { is_valid: [2, 1] },
  negative_mentions_ratio: { sentiment: [1] },
};
